import { createProductOptions } from '../utils';
import { ProductConfigResponse } from './ProductConfiguration.types';

export const wait = (time: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, time));

class ProductConfigurationMock {
  public getProductConfiguration(
    requestData: unknown,
  ): Promise<ProductConfigResponse> {
    return wait(1000)
      .then(() => {
        if (Object.hasOwnProperty.call(requestData, 'category')) {
          return {
            options: createProductOptions([
              'Zegarki damskie',
              'Zegarki męskie',
              'Zegarki sportowe',
            ]),
          };
        }

        return { options: createProductOptions(['Zegarki', 'Zegarki sportowe']) };
      });
  }
}

export const productConfigurationMock = new ProductConfigurationMock();
